module.exports = __webpack_public_path__ + "static/gulls-b8deeca08c9309ecb4eff6d0e3c95029.jpg";